<template>
  <el-card>
    <div slot="header" class="header">
      <span>设备类型</span>
    </div>
    <el-menu
      @select="deviceChange"
      :default-active="DeviceType"
      text-color="#333"
      active-text-color="#333"
      background-color="#f4f4f4"
    >
      <el-menu-item v-for="item in menuList" :key="item.id" :index="item.id">
        <Ellipsis slot="title" :texts="item.title" :length="22" />
      </el-menu-item>
    </el-menu>
  </el-card>
</template>
<script>
import deviceApi from 'api/home/device-mangement';
import Ellipsis from '@/components/Ellipsis';
export default {
  components: {
    Ellipsis
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: String
    }
  },
  data() {
    return {
      DeviceType: '',
      menuList: [{}]
    };
  },
  watch: {
    value: {
      immediate: true,
      handler: function (newVal) {
        this.DeviceType = newVal;
      }
    },
    DeviceType: {
      immediate: true,
      handler: function (newVal) {
        this.$emit('change', newVal);
        this.$emit('typeChange');
      }
    }
  },
  created() {
    deviceApi.getDeviceTypeList().then(res => {
      this.menuList = res.data.data.map(item => {
        return {
          id: item.id,
          title: item.categoryName,
          categoryNo: item.categoryNo
        };
      });
      this.menuList.unshift({ id: '', title: '全部', categoryNo: '' });
    });
  },
  methods: {
    deviceChange(index) {
      this.DeviceType = index;
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-card__header {
  background: #409dfb;
  color: #ffffff;
}
/deep/ .el-menu-item.is-active {
  background-color: #deefff !important;
}
</style>